<template>

    <v-container id="user-profile" class="d-flex justify-center">

        <v-card
                elevation="0"
                class="pa-0 ma-0"
                max-width="730"
                :min-width="$vuetify.breakpoint.mdAndUp? '730':''"
        >
            <v-tabs
                center-active
                v-model="activeTab"
                class="user-profile-tabs"
                slider-size="3"
                :grow="$vuetify.breakpoint.smAndDown"
                :centered="$vuetify.breakpoint.smAndDown"
            >

                <v-tab v-for="tab in tabs" :key="tab.index" @click="updateUrl($event, tab.toUrl)">{{tab.name}}</v-tab>

                <v-tab-item>
                    <StudentDashboard :active-user="user" />
                </v-tab-item>

                <v-tab-item>
                   <AccountSettings :active-user="user" />
                </v-tab-item>

                <v-tab-item>
                    <CrowdfundingTab :active-user="user" />
                </v-tab-item>

            </v-tabs>
        </v-card>


    </v-container>

</template>

<script>
import StudentDashboard from "./StudentDashboard";
import AccountSettings from "./AccountSettings";
import CrowdfundingTab from "./CrowdfundingTab";

export default {

  name: 'UserInfo',
    components: {
        StudentDashboard,
        AccountSettings,
        CrowdfundingTab,
    },
    watch: {
      $route (to) {
          this.switchActiveTab(to.name);
        }
    },
    data: () => ({
        activeTab: 0,
        tabs: [
            { index: 0, name: 'Student Dashboard', toUrl: '/student-dashboard' },
            { index: 1, name: 'Account Settings', toUrl: '/account-settings' },
            { index: 2, name: 'Crowdfunding', toUrl: '/crowdfunding' }
        ]
    }),

    computed: {
        user() {
            return this.$store.getters.getUser
        }
    },

    beforeMount() {
        this.switchActiveTab(this.$router.currentRoute.name);
    },
    methods: {
      switchActiveTab(tabName) {
          switch (tabName) {
              case 'StudentDashboard':
                  this.activeTab = 0;
                  break;
              case 'AccountSettings':
                  this.activeTab = 1;
                  break;
              case 'CrowdfundingTab':
                  this.activeTab = 2;
                  break;
              default:
                  this.activeTab = 0;
          }
      },
        updateUrl(event, url) {
          event.preventDefault();

          this.$router.push(url);
        }
    }
}
</script>
<style>

    #user-profile {
        padding-left: 0;
        padding-right: 0;
    }

    .user-profile-tabs .v-slide-group {
        margin-bottom: 30px;
        margin-top: 10px;
    }
    .user-profile-tabs .v-slide-group__wrapper {
        border-bottom: 1px solid #d8d8d8 !important;
    }
    .user-profile-tabs .v-tab {
        text-transform: unset;
        letter-spacing: 0;
        font-size: 16px;
        font-weight: 400;
        color: #000 !important;
    }
    .user-profile-tabs .v-tab--active {
        color: #000;
    }
    .user-profile-tabs .results-found {
        font-size: 14px !important;
    }

</style>
